import { TopProject } from '../types/globalTypes';
import { formatCreationDate } from './formatCreationDate';

interface GroupedProjects {
  [date: string]: TopProject[];
}

interface GroupedProjectsResult {
  groupedProjects: GroupedProjects;
  sortedDates: string[];
}

export const groupProjectsByDate = (
  projects: TopProject[]
): GroupedProjectsResult => {
  const grouped: GroupedProjects = {};

  projects.forEach(project => {
    if (project.BecameAvailableDate) {
      const date = formatCreationDate(project.BecameAvailableDate);
      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(project);
    }
  });

  const sortedDates = Object.keys(grouped).sort((a, b) => {
    const dateA = new Date(grouped[a][0].BecameAvailableDate || '');
    const dateB = new Date(grouped[b][0].BecameAvailableDate || '');
    return dateB.getTime() - dateA.getTime();
  });

  return {
    groupedProjects: grouped,
    sortedDates: sortedDates,
  };
};
